export default __webpack_public_path__ + "static/map-86accacf61153f1af3927d9fb6452fac.png";